export const ENVIORNMENT = "uat";
export const VERSION = "78";
export const DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS";

export function isLocal() {
    let env = ENVIORNMENT.toLowerCase();
    return !(env.includes('dev') || env.includes('uat') || env.includes('prod'));
}

export function isDev() {
    return ENVIORNMENT.toLowerCase().includes('dev');
}

export function isUAT() {
    return ENVIORNMENT.toLowerCase().includes('uat');
}

export function isProd() {
    return ENVIORNMENT.toLowerCase().includes('prod');
}

export function getApiEndPoint(){
   return  isLocal() ? 'http://localhost:52651/api/v1' : '/api/v1';
}



// WEBPACK FOOTER //
// ./app/configurations.js